export const BuildInfo = () => (
  <div className='build-info' style={{ display: 'none' }}>
    {window.buildInfo || 'No build info'}
  </div>
);
